import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import NewsCard from 'fragments/NewsCard';

export default withFragments(
  gql`
    fragment LatestNews on LatestNewsBlock {
      title
      latestNews(hostname: $hostname) {
        parent {
          url
        }
        ...NewsCard
      }
    }
  `,
  { NewsCard },
);
